import { WorkflowType } from "./workflow-type";

export class CreateInstanceRequest {
  assetId: number | null = 0;
  annotation: string | null = null;
  definitionType: WorkflowType | null = null;
  definitionId: number | null = 0;
  inboundVars?: Record<string, string> | null = null;
  aclElevationId?: number | null = null;

  constructor(init?: Partial<CreateInstanceRequest>) {
    Object.assign(this, init);
  }
}
